<template lang='pug' src='./custom-home-apart.pug'></template>

<script>
export default {
  props: {
    content: {
      type: [Object, Array]
    }
  },
  mounted () {
    setTimeout(() => {
      this.$refs.fade.classList.add('custom-home-apart--fade')
    }, 10)
    setTimeout(() => {
      this.$refs.slide.forEach((image, i) => {
        image.classList.add('custom-home-apart__image--slide')
      })
    }, 100)
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-apart.vue?7a8bbb81